import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { addDoc, updateDoc } from "firebase/firestore";
import { aoiCollectionRef, getAoiDoc } from "../utils/firestoreHelpers";
import { useState } from "react";

const initialErrorData = {
  title: "",
  description: "",
  type: "",
};

const EditAOI = ({ onClose, data, refresh, type_list }) => {
  const [title, setTitle] = useState(data?.title || "");
  const [description, setDescription] = useState(data?.description || "");
  const [type, setType] = useState(data?.type || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ ...initialErrorData });

  // const validate = () => {
  //   let isValid = true;
  //   let tempError = { ...initialErrorData };
  //   if (!title) {
  //     isValid = false;
  //     tempError["title"] = "Title is required";
  //   }
  //   if (!description) {
  //     isValid = false;
  //     tempError["description"] = "Description is required";
  //   }
  //   if (!type) {
  //     isValid = false;
  //     tempError["type"] = "Category is required";
  //   }
  //   setError(tempError);
  //   return isValid;
  // };
  const validate = () => {
    let isValid = true;
    let tempError = { ...initialErrorData };

    const cleanTitle = title.trim();
    const cleanDesc = description.trim();
    const cleanType = type.trim();

    //  Title
    if (!cleanTitle) {
      isValid = false;
      tempError.title = "Title is required";
    } else if (cleanTitle.length < 3 || cleanTitle.length > 200) {
      isValid = false;
      tempError.title = "Title must be between 3 and 200 characters";
    }

    //  Description
    if (!cleanDesc) {
      isValid = false;
      tempError.description = "Description is required";
    } else if (cleanDesc.length < 3 || cleanDesc.length > 500) {
      isValid = false;
      tempError.description =
        "Description must be between 3 and 500 characters";
    }

    //  Category
    if (!cleanType) {
      isValid = false;
      tempError.type = "Category is required";
    } else if (cleanType.length < 3 || cleanType.length > 200) {
      isValid = false;
      tempError.type = "Category must be between 3 and 200 characters";
    }

    setError(tempError);
    return isValid;
  };

  const create = async () => {
    let isValid = validate();
    if (!isValid) return;
    setLoading(true);
    try {
      const payload = {
        title: title.trim(),
        description: description.trim(),
        type: type.trim(),
      };
      if (data) {
        const aoiDoc = getAoiDoc(data.id);
        await updateDoc(aoiDoc, payload);
      } else {
        await addDoc(aoiCollectionRef, payload);
      }
      refresh();
      onClose();
      setTitle('');
      setDescription('');
      setType('');
    } catch (e) {
      console.log("error", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form>
      <Modal show={true} onHide={() => {}}>
        <Modal.Header>
          <Modal.Title>
            {data ? "Edit Area Of Interest" : "Add Area Of Interest"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div>Title *</div>
            <input
              value={title}
              maxLength={200}
              onChange={(e) => {
                setTitle(e.target.value);
                setError((prev) => ({ ...prev, title: "" }));
              }}
              // readOnly={!!data}
              className="w-100 form-control"
            />
            <p className="text-danger small">{error.title}</p>
          </div>
          <div className="mb-3">
            <div>Description *</div>
            <input
              value={description}
              className="w-100 form-control"
              maxLength={500}
              rows={4}
              onChange={(e) => {
                setDescription(e.target.value);
                setError((prev) => ({ ...prev, description: "" }));
              }}
            />
            <p className="text-danger small">{error.description}</p>
          </div>
          <div>
            <div>Select an older category *</div>
            <select
              value={type}
              onChange={(e) => {
                setType(e.target.value);
                setError((prev) => ({ ...prev, type: "" }));
              }}
              className="w-100 form-control"
            >
              <option value="">Select category</option>
              {type_list.map((t) => (
                <option key={t}>{t} </option>
              ))}
            </select>
            Or / Create a new category
            <input
              value={type}
              maxLength={200}
              onChange={(e) => {
                setType(e.target.value);
                setError((prev) => ({ ...prev, type: "" }));
              }}
              placeholder="Enter new category"
              className="w-100 form-control"
            />
            <p className="text-danger small">{error.type}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={create} disabled={loading}>
            {loading ? (
              <>
                <span
                  class="spinner-grow spinner-grow-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </>
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </form>
  );
};

export default EditAOI;
